import React from "react";
import { Grid } from "@mui/material";

export default function TypographyContainer({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <>
      <Grid container size={{ xs: 12 }}>
        {children}
      </Grid>
    </>
  );
}
